import React, { useEffect, useRef, useState } from "react";
import { FaMicrophone, FaMicrophoneSlash, FaPhoneSlash } from "react-icons/fa"; 
import "../css/callScreen.css";

export default function CallScreen({ localStream, remoteStream, onEnd }) {
  const localRef = useRef(null);
  const remoteRef = useRef(null);
  const [callTime, setCallTime] = useState(0);
  const [isMuted, setIsMuted] = useState(false);

  // 1. Handle Local Stream (My Video/Audio)
  useEffect(() => {
    if (localRef.current && localStream) {
      localRef.current.srcObject = localStream;
      // Ensure video track is enabled if present
      const videoTracks = localStream.getVideoTracks();
      if (videoTracks.length > 0) videoTracks[0].enabled = true;
    }
  }, [localStream]);

  // 2. Handle Remote Stream (Their Video/Audio)
  useEffect(() => {
    if (remoteRef.current && remoteStream) {
      console.log("🎥 Setting Remote Stream tracks:", remoteStream.getTracks());
      remoteRef.current.srcObject = remoteStream;
      
      remoteRef.current.play().catch(err => {
        console.warn("Autoplay prevented:", err);
      });
    }
  }, [remoteStream]);

  // 3. Call Timer
  useEffect(() => {
    const timer = setInterval(() => setCallTime((prev) => prev + 1), 1000);
    return () => clearInterval(timer);
  }, []);

  const formatTime = (seconds) => {
    const m = Math.floor(seconds / 60).toString().padStart(2, "0");
    const s = (seconds % 60).toString().padStart(2, "0");
    return `${m}:${s}`;
  };

  // ✅ FIXED: Correct Mute Logic
  const toggleMute = () => {
    if (localStream) {
      const newMutedState = !isMuted; // Calculate new state first
      
      localStream.getAudioTracks().forEach((track) => {
        // If we want to be MUTED (true), enabled should be FALSE
        // If we want to be UNMUTED (false), enabled should be TRUE
        track.enabled = !newMutedState; 
      });
      
      setIsMuted(newMutedState); // Update UI state
    }
  };

  return (
    <div className="call-screen-container">
      {/* --- Remote Video (Full Screen Background) --- */}
      <video
        ref={remoteRef}
        className="remote-video"
        autoPlay
        playsInline
      />

      {/* --- Local Video (Floating Picture-in-Picture) --- */}
      {localStream && localStream.getVideoTracks().length > 0 && (
        <div className="local-video-wrapper">
          <video
            ref={localRef}
            className="local-video"
            autoPlay
            muted // Always mute local video to prevent echo
            playsInline
          />
        </div>
      )}

      {/* --- Controls Overlay --- */}
      <div className="call-overlay">
        <div className="call-info">
          <div className="timer-badge">{formatTime(callTime)}</div>
          {(!remoteStream || remoteStream.getVideoTracks().length === 0) && (
             <div className="voice-only-label">Voice Call</div>
          )}
        </div>

        <div className="controls-bar">
          <button 
            onClick={toggleMute} 
            className={`control-btn ${isMuted ? "muted" : ""}`}
            title={isMuted ? "Unmute" : "Mute"}
          >
            {isMuted ? <FaMicrophoneSlash /> : <FaMicrophone />}
          </button>

          <button onClick={onEnd} className="control-btn end-call">
            <FaPhoneSlash />
          </button>
        </div>
      </div>
    </div>
  );
}